import React from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { PostData } from "../../store/actions";
import swal from "sweetalert";

const initialValues = {
  collection_name: "",
  contract_address: "",
  email_id: "",
  project_logo: "",
  project_desc: "",
  project_lissting_sales_url: "",
  project_website: "",
  discord_server_link: "",
  twitter_link: "",
  telegram_link: "",
  token_standard: "",
  acceleration_fee: "",
};

function Request() {
  const disptach = useDispatch();

  const Form = useFormik({
    initialValues,
    validationSchema: Yup.object({
      collection_name: Yup.string()
        .max(60, "Must be 60 characters or less")
        .required("Required"),
      contract_address: Yup.string()
        .max(60, "Must be 60 characters or less")
        .required("Required"),
      email_id: Yup.string()
        .email("Invalid email address")
        .required("Required"),
      project_logo: Yup.string(),
      project_desc: Yup.string(),
      project_lissting_sales_url: Yup.string(),
      project_website: Yup.string(),
      discord_server_link: Yup.string(),
      twitter_link: Yup.string(),
      telegram_link: Yup.string(),
      token_standard: Yup.string(),
      acceleration_fee: Yup.string(),
    }),
    onSubmit: async (values, Helpers) => {
      const res = await disptach(PostData("nftlistingadmin", values));
      if (res.status) {
        swal(res.result).then((value) => {
          Helpers.resetForm();
        });
      }
    },
  });

  return (
    <main className="float-top position-relative">
      <section>
        <div className="container">
          <h3 className="title">Request for Listing</h3>
          <div className="boxs bg-secondary request-form">
            <p className="f-16 brand-gray pb">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
            <form
              className="form border-0 rounded-0 p-0 pr-lg-5 mr-lg-5"
              onSubmit={Form.handleSubmit}
            >
              <div className="row">
                <div className="col-md-6 form-group pb mb-0">
                  <label htmlFor="">What is your project name?</label>
                  <input
                    type="text"
                    id=""
                    name="collection_name"
                    className={`form-control ${
                      Form.touched.collection_name &&
                      Form.errors.collection_name
                        ? "is-invalid"
                        : Form.touched.collection_name
                        ? "is-valid"
                        : ""
                    }`}
                    placeholder="Enter"
                    onChange={Form.handleChange}
                    onBlur={Form.handleBlur}
                    value={Form.values.collection_name}
                  />
                  {Form.touched.collection_name &&
                  Form.errors.collection_name ? (
                    <div className="invalid-feedback">
                      {Form.errors.collection_name}
                    </div>
                  ) : null}
                </div>
                <div className="col-md-6 form-group pb mb-0">
                  <label htmlFor="">
                    Please provide token contract address.*
                  </label>
                  <input
                    type="text"
                    id=""
                    name="contract_address"
                    className={`form-control ${
                      Form.touched.contract_address &&
                      Form.errors.contract_address
                        ? "is-invalid"
                        : Form.touched.contract_address
                        ? "is-valid"
                        : ""
                    }`}
                    placeholder="Enter"
                    onChange={Form.handleChange}
                    onBlur={Form.handleBlur}
                    value={Form.values.contract_address}
                  />
                  {Form.touched.contract_address &&
                  Form.errors.contract_address ? (
                    <div className="invalid-feedback">
                      {Form.errors.contract_address}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 form-group pb mb-0">
                  <label htmlFor="">
                    Please provide an email address. This is our primary method
                    of communication.*
                  </label>
                  <input
                    type="text"
                    name="email_id"
                    id=""
                    className={`form-control ${
                      Form.touched.email_id && Form.errors.email_id
                        ? "is-invalid"
                        : Form.touched.email_id
                        ? "is-valid"
                        : ""
                    }`}
                    placeholder="Enter Email"
                    onChange={Form.handleChange}
                    onBlur={Form.handleBlur}
                    value={Form.values.email_id}
                  />
                  {Form.touched.email_id && Form.errors.email_id ? (
                    <div className="invalid-feedback">
                      {Form.errors.email_id}
                    </div>
                  ) : null}
                </div>
                <div className="col-md-6 form-group pb mb-0">
                  <label htmlFor="">
                    Please provide url to your project's logo/image in .png
                    format (this is your logo that will be displayed on site
                    representing your project) *
                  </label>
                  <input
                    type="text"
                    id=""
                    name="project_logo"
                    className={`form-control ${
                      Form.touched.project_logo && Form.errors.project_logo
                        ? "is-invalid"
                        : Form.touched.project_logo
                        ? "is-valid"
                        : ""
                    }`}
                    placeholder="Enter"
                    onChange={Form.handleChange}
                    onBlur={Form.handleBlur}
                    value={Form.values.project_logo}
                  />
                  {Form.touched.project_logo && Form.errors.project_logo ? (
                    <div className="invalid-feedback">
                      {Form.errors.project_logo}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="row" onChange={Form.handleChange}>
                <div className="col form-group d-flex flex-wrap pb mb-0">
                  <label
                    className={`break ${
                      Form.touched.token_standard && Form.errors.token_standard
                        ? "is-invalid"
                        : Form.touched.token_standard
                        ? "is-valid"
                        : ""
                    }`}
                    htmlFor=""
                  >
                    What is your token standard? *
                  </label>
                  <div className="form-check mr-md-3 pl-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      onChange={() => {}}
                      checked={
                        Form.values.token_standard == "AA (Atomic Assets - Wax)"
                      }
                      onClick={() => {}}
                      name="token_standard"
                      id="check1"
                      value="AA (Atomic Assets - Wax)"
                    />
                    <label className="form-check-label" htmlFor="check1">
                      AA (Atomic Assets - Wax)
                    </label>
                  </div>
                  <div className="form-check mr-md-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      onChange={() => {}}
                      onClick={() => {}}
                      name="token_standard"
                      id="check2"
                      checked={Form.values.token_standard == "ERC 721"}
                      value="ERC 721"
                    />
                    <label className="form-check-label" htmlFor="check2">
                      ERC 721
                    </label>
                  </div>
                  <div className="form-check mr-md-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      onChange={() => {}}
                      onClick={() => {}}
                      name="token_standard"
                      id="check3"
                      checked={Form.values.token_standard == "Flow"}
                      value="Flow"
                    />
                    <label className="form-check-label" htmlFor="check3">
                      Flow
                    </label>
                  </div>
                  <div className="form-check mr-md-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      onChange={() => {}}
                      onClick={() => {}}
                      name="token_standard"
                      checked={Form.values.token_standard == "ERC 1155"}
                      id="check4"
                      value="ERC 1155"
                    />
                    <label className="form-check-label" htmlFor="check4">
                      ERC 1155
                    </label>
                  </div>
                  <div className="form-check mr-md-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      onChange={() => {}}
                      onClick={() => {}}
                      name="token_standard"
                      id="check5"
                      checked={Form.values.token_standard == "BSC"}
                      value="BSC"
                    />
                    <label className="form-check-label" htmlFor="check5">
                      BSC
                    </label>
                  </div>
                  <div className="form-check mr-md-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      onChange={() => {}}
                      onClick={() => {}}
                      name="token_standard"
                      id="check6"
                      checked={Form.values.token_standard == "Other"}
                      value="Other"
                    />
                    <label className="form-check-label" htmlFor="check6">
                      Other
                    </label>
                  </div>
                  {Form.errors.token_standard ? (
                    <div className="invalid-feedback">
                      {Form.errors.token_standard}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="row">
                <div className="col form-group pb mb-0">
                  <label htmlFor="">Please describe your project *</label>
                  <textarea
                    className={`form-control ${
                      Form.touched.project_desc && Form.errors.project_desc
                        ? "is-invalid"
                        : Form.touched.project_desc
                        ? "is-valid"
                        : ""
                    }`}
                    id=""
                    placeholder="Enter"
                    name="project_desc"
                    onChange={Form.handleChange}
                    onBlur={Form.handleBlur}
                    value={Form.values.project_desc}
                  ></textarea>
                  {Form.touched.project_desc && Form.errors.project_desc ? (
                    <div className="invalid-feedback">
                      {Form.errors.project_desc}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 form-group pb mb-0">
                  <label htmlFor="">
                    Please provide a link to your project listings and sales *
                  </label>
                  <input
                    type="text"
                    id=""
                    name="project_lissting_sales_url"
                    className={`form-control ${
                      Form.touched.project_lissting_sales_url &&
                      Form.errors.project_lissting_sales_url
                        ? "is-invalid"
                        : Form.touched.project_lissting_sales_url
                        ? "is-valid"
                        : ""
                    }`}
                    placeholder="Enter"
                    onChange={Form.handleChange}
                    onBlur={Form.handleBlur}
                    value={Form.values.project_lissting_sales_url}
                  />
                  {Form.touched.project_lissting_sales_url &&
                  Form.errors.project_lissting_sales_url ? (
                    <div className="invalid-feedback">
                      {Form.errors.project_lissting_sales_url}
                    </div>
                  ) : null}
                </div>
                <div className="col-md-6 form-group pb mb-0">
                  <label htmlFor="">
                    Please provide a link to your project's website *
                  </label>
                  <input
                    type="text"
                    id=""
                    name="project_website"
                    className={`form-control ${
                      Form.touched.project_website &&
                      Form.errors.project_website
                        ? "is-invalid"
                        : Form.touched.project_website
                        ? "is-valid"
                        : ""
                    }`}
                    placeholder="Enter"
                    onChange={Form.handleChange}
                    onBlur={Form.handleBlur}
                    value={Form.values.project_website}
                  />
                  {Form.touched.project_website &&
                  Form.errors.project_website ? (
                    <div className="invalid-feedback">
                      {Form.errors.project_website}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 form-group pb mb-0">
                  <label htmlFor="">
                    Please provide a link to your Discord server. *
                  </label>
                  <input
                    type="text"
                    id=""
                    name="discord_server_link"
                    className={`form-control ${
                      Form.touched.discord_server_link &&
                      Form.errors.discord_server_link
                        ? "is-invalid"
                        : Form.touched.discord_server_link
                        ? "is-valid"
                        : ""
                    }`}
                    placeholder="Enter"
                    onChange={Form.handleChange}
                    onBlur={Form.handleBlur}
                    value={Form.values.discord_server_link}
                  />
                  {Form.touched.discord_server_link &&
                  Form.errors.discord_server_link ? (
                    <div className="invalid-feedback">
                      {Form.errors.discord_server_link}
                    </div>
                  ) : null}
                </div>
                <div className="col-md-6 form-group pb mb-0">
                  <label htmlFor="">
                    Please provide a link to your Twitter *
                  </label>
                  <input
                    type="text"
                    id=""
                    className={`form-control ${
                      Form.touched.twitter_link && Form.errors.twitter_link
                        ? "is-invalid"
                        : Form.touched.twitter_link
                        ? "is-valid"
                        : ""
                    }`}
                    name="twitter_link"
                    placeholder="Enter"
                    onChange={Form.handleChange}
                    onBlur={Form.handleBlur}
                    value={Form.values.twitter_link}
                  />
                  {Form.touched.twitter_link && Form.errors.twitter_link ? (
                    <div className="invalid-feedback">
                      {Form.errors.twitter_link}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 form-group pb mb-0">
                  <label htmlFor="">
                    Please provide a link to your Telegram *
                  </label>
                  <input
                    type="text"
                    id=""
                    name="telegram_link"
                    className={`form-control ${
                      Form.touched.telegram_link && Form.errors.telegram_link
                        ? "is-invalid"
                        : Form.touched.telegram_link
                        ? "is-valid"
                        : ""
                    }`}
                    placeholder="Enter"
                    onChange={Form.handleChange}
                    onBlur={Form.handleBlur}
                    value={Form.values.telegram_link}
                  />
                  {Form.touched.telegram_link && Form.errors.telegram_link ? (
                    <div className="invalid-feedback">
                      {Form.errors.telegram_link}
                    </div>
                  ) : null}
                </div>
                <div
                  onChange={Form.handleChange}
                  className="col-md-6 form-group d-flex flex-wrap pb mb-0"
                >
                  <label
                    className={`break ${
                      Form.touched.acceleration_fee &&
                      Form.errors.acceleration_fee
                        ? "is-invalid"
                        : Form.touched.acceleration_fee
                        ? "is-valid"
                        : ""
                    }`}
                    htmlFor=""
                  >
                    If you are interested in paying a $2,000 acceleration fee to
                    prioritize your listing to the top of the queue lease
                    indicate so below. *
                  </label>
                  <div className="form-check mr-md-3 pl-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      onChange={() => {}}
                      onClick={() => {}}
                      name="acceleration_fee"
                      id="ans-yes"
                      value="1"
                    />
                    <label className="form-check-label" htmlFor="ans-yes">
                      Yes
                    </label>
                  </div>
                  <div className="form-check mr-md-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      onChange={() => {}}
                      onClick={() => {}}
                      name="acceleration_fee"
                      id="ans-no"
                      value="0"
                    />
                    <label className="form-check-label" htmlFor="ans-no">
                      No
                    </label>
                  </div>
                  {Form.errors.acceleration_fee ? (
                    <div className="invalid-feedback">
                      {Form.errors.acceleration_fee}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="btn-group">
                <input
                  className="btn-primary mr-3"
                  type="submit"
                  name=""
                  disabled={Form.isSubmitting}
                  value="Submit"
                />
                <a href="" className="btn-secondary ml-lg-3">
                  Clear Form
                </a>
              </div>
            </form>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Request;
